<ng-select
    [(ngModel)]="selectLang"
    [items]="langItems"
    [clearable]="false"
    bindLabel="name"
    (change)="updateLang()"
></ng-select>
